import React, {useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {VatTypeEnum} from "src/enums/VatTypeEnum";
import {AmountHelper} from "src/helpers/AmountHelper";
import {NFIntInput} from "src/components/Shared/NewForms/NFIntInput";
import {EnumHelper} from "src/helpers/EnumHelper";
import {NFormTable} from "src/components/Shared/NewForms/NFormTable";
import {NFLookupProduct} from "src/components/Shared/NewForms/NFLookupProduct";
import {NFPlainText} from "src/components/Shared/NewForms/NFPlainText";
import {NFLookupUnit} from "src/components/Shared/NewForms/NFLookupUnit";
import {NFLookupInput} from "src/components/Shared/NewForms/NFLookupInput";
import {AppServices} from "../../../../../../config/entities";
import {DataGrid} from "devextreme-react";
import {Column} from "devextreme-react/data-grid";
import {IPurchaseOrderProductDto} from "../dtos/IPurchaseOrderProductDto";
import {NFLookupEntity} from "src/components/Shared/NewForms/NFLookupEntity/NFLookupEntity";
import {NFLookupEntityColumn} from "../../../../../Shared/NewForms/NFLookupEntity/NFLookupEntityColumn";

export const PurchaseOrderDetailProducts = () => {
    const tableName = "products";
    const {watch, setValue, getValues} = useFormContext();
    const {t} = useTranslation();
    const [products, setProducts] = React.useState<IPurchaseOrderProductDto[]>([]);

    const watchId = watch("id");

    const handleVatTypeChanged = (newVatType: VatTypeEnum, index: number) => {
        setValue(
            `${tableName}.${index}.vatAmount`,
            AmountHelper.getVatAmount(
                newVatType,
                getValues(`${tableName}.${index}.amount`),
                getValues("priceIncludesVat")
            )
        );
    };

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const fetchProducts = async () => {
        const requestDto = {
            purchaseOrderId: watchId,
        };

        const response = await AppServices.Axios.post(`/PurchaseOrders/GetProductsById`, requestDto);
        console.log("response.data", response.data)
        setProducts(response.data);
        // setValue("products", response.data);
    }

    useEffect(() => {
        if (watchId) {
            fetchProducts();
        }
    }, [watchId]);

    useEffect(() => {
        console.log("products", products)
    }, [products]);

    const productEditCellComponent = (props: any) => {
        console.log("productEditCellComponent props", props)
        const dataField = props.data.column.dataField;
        const data = props.data.data;
        
        const itemId = data[`${dataField}Id`];
        const itemName = data[`${dataField}Name`];
        
        return (
            <>
                <NFLookupEntity id={itemId} text={itemName}>
                    <NFLookupEntityColumn type={"string"} fieldName={"id"} caption={"Id"} />
                    <NFLookupEntityColumn type={"string"} fieldName={"name"} caption={"Name"} />
                </NFLookupEntity>
            </>
        )
    }
    
    const productCellComponent = (props: any) => {
        console.log("productCellComponent props", props)
        const dataField = props.data.column.dataField;
        const data = props.data.data;
        
        return (
            <>
                {data[`${dataField}Name`]}
            </>
        )
    }

    return (
        <>
            <DataGrid dataSource={products}
                      showBorders={true}
                      editing={{
                          mode: "cell",
                          allowUpdating: true,
                          allowDeleting: true,
                          allowAdding: false
                      }}>
                <Column dataField={"lineNo"} caption={t("#")} width={50}/>
                <Column dataField="product" caption={t("Product")} cellComponent={productCellComponent}
                        editCellComponent={productEditCellComponent}/>
                <Column dataField="productVendorCode" caption={t("vendorCode")}/>
                <Column dataField="unitId" caption={t("Unit")}/>
                <Column dataField="vatTaxationType" caption={t("Taxation")}/>
                <Column dataField="vatType" caption={t("vatType")}/>
                <Column dataField="quantity" caption={t("Quantity")}/>
                <Column dataField="price" caption={t("Price")}/>
                <Column dataField="amount" caption={t("Amount")}/>
                <Column dataField="amountWithVat" caption={t("amountWithVat")}/>
                <Column dataField="vatAmount" caption={t("vatAmount")}/>
            </DataGrid>
            {/*<NFormTable fieldArray={tableName}>*/}
            {/*    <NFLookupProduct*/}
            {/*        title={t("Product")}*/}
            {/*        fieldName={"productId"}*/}
            {/*        width={200}*/}
            {/*    />*/}
            {/*    <NFPlainText*/}
            {/*        title={t("vendorCode")}*/}
            {/*        fieldName="productVendorCode"*/}
            {/*        width={200}*/}
            {/*    />*/}
            {/*    <NFLookupUnit*/}
            {/*        title={t("Unit")}*/}
            {/*        fieldName="unitId"*/}
            {/*        width={200}*/}
            {/*        required={true}*/}
            {/*    />*/}
            {/*    <NFLookupInput*/}
            {/*        title={t("Taxation")}*/}
            {/*        fieldName="vatTaxationType"*/}
            {/*        items={EnumHelper.GetVatTaxationTypeArrayForLookup()}*/}
            {/*        width={150}*/}
            {/*    />*/}
            {/*    <NFLookupInput*/}
            {/*        title={t("vatType")}*/}
            {/*        fieldName={"vatType"}*/}
            {/*        items={EnumHelper.GetVatTypeArrayForLookup()}*/}
            {/*        width={150}*/}
            {/*    />*/}
            {/*    <NFIntInput*/}
            {/*        fieldName={"quantity"}*/}
            {/*        title={t("Quantity")}*/}
            {/*        onValueChanged={handleQuantityChanged}*/}
            {/*        width={100}*/}
            {/*    />*/}
            {/*    <NFIntInput*/}
            {/*        fieldName={"price"}*/}
            {/*        title={t("Price")}*/}
            {/*        onValueChanged={handlePriceChanged}*/}
            {/*        width={100}*/}
            {/*    />*/}
            {/*    <NFIntInput title={t("Amount")} fieldName="amount"/>*/}
            {/*    <NFIntInput*/}
            {/*        title={t("amountWithVat")}*/}
            {/*        fieldName="amountWithVat"*/}
            {/*    />*/}
            {/*    <NFIntInput title={t("vatAmount")} fieldName="vatAmount"/>*/}
            {/*</NFormTable>*/}
        </>
    );
};
